// extracted by mini-css-extract-plugin
module.exports = {"textAreaWidth":"textAreaWidth-a728b16d"};